module.exports = __webpack_public_path__ + "img/image5.133bd568.jpg";